import Loadable from 'react-loadable';

const LoadableAgentLeadReferralContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "agentLeadReferralContainer" */ './index'),
  loading: () => null,
});

export default LoadableAgentLeadReferralContainer;
